import React, { useRef } from "react";

import { useState } from "react";
import { useEffect } from "react";
import { getUserData } from "../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import SuccessModal from "../SuccessModal";
import { postQrCodeByStatus } from "../../services/QrCode/postQrCodeByStatus";
import { postBulkQrCode } from "../../services/QrCode/postBulkQrCode";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import addItemSound from '../../assets/sounds/warehousesound3.mp3';
import BeepSound from '../../assets/sounds/alert-beep.wav';
const { innerWidth: width, innerHeight: height } = window;

const PartialMarkReady = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeCustomerId, bookingOrderId } = location.state || {}; // Fallback to prevent undefined errors

  const [rfidMethod, setRfidMethod] = useState(false);

  const { brandProfileData, storeData, userProfileData, userProfileRole } =
    getUserData();
  let storeId = storeData.id;

  const userRole = userProfileRole;

  const audioRef = useRef(new Audio(addItemSound));
    const handleAddItem = () => {
      const audio = audioRef.current;
      audio.currentTime = 0; // Restart from beginning
      audio.play();
    };
  
  const inputRef = useRef(null);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [tagInfo, setTagInfo] = useState([]);
  const [selectedQrCodeItems, setSelectedQrCodeItems] = useState([]);
  const [selectedQrCodeItemsDetails, setSelectedQrCodeItemsDetails] = useState(
    []
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(false);

  const [searchTermFocus, setSearchTermFocus] = useState("");

  const handleBackButton = () => {
    if (userRole === "BY_STORE") {
      navigate("/OrdersGarmentInfo", {
        state: {
          storeCustomerId: storeCustomerId,
          bookingOrderId: bookingOrderId,
        },
      });
    } else {
      navigate("Home");
    }
  };

  const refocusInput = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus(); // Refocus the input
      }
    }, 10); // Add slight delay to ensure it focuses after processing
  };


  const fetchQrCode = () => {
    const data = {
      status: ["IN_PROCESS"],
    };
    postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.map((item) => ({
            ...item,
            checked: false,
          }));
          setTagInfo(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchQrCode();
  }, []);

  const selectAllCheckboxes = () => {
    const updatedData = tagInfo.map((item) => ({
      ...item,
      checked: !isCheckedAll,
    }));
    setTagInfo(updatedData);
    setIsCheckedAll(!isCheckedAll);
    // Update selected items and details arrays based on the selected items after the select all operation
    if (!isCheckedAll) {
      const newSelectedQrCodeItems = tagInfo.map((item) => item.id);
      const newSelectedQrCodeItemsDetails = tagInfo.map((item) => ({
        ...item,
      }));
      setSelectedQrCodeItems(newSelectedQrCodeItems);
      setSelectedQrCodeItemsDetails(newSelectedQrCodeItemsDetails);
    } else {
      setSelectedQrCodeItems([]);
      setSelectedQrCodeItemsDetails([]);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  const filterUserList = () => {
    return tagInfo.filter((item) => {
      const qrcode = item.qrcode?.toLowerCase();
      const garmentAlias = item.garmentAlias?.toLowerCase();
      const garment = item.garment?.toLowerCase();
      const category = item.category?.toLowerCase();
      const rfid = item.rfid?.toLowerCase();
      const matchesSearchTermQrcode = qrcode?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermGarmentAlias = garmentAlias?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermGarment = garment?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermCategory = category?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermRfid = rfid?.includes(
        searchTerm.toLowerCase()
      );
      return (
        matchesSearchTermGarmentAlias ||
        matchesSearchTermGarment ||
        matchesSearchTermQrcode ||
        matchesSearchTermCategory || 
        matchesSearchTermRfid
      );
    });
  };

  const filteredData = filterUserList();

  useEffect(() => {
    // Check if all items are selected
    const allItemsSelected = tagInfo.every((item) => item.checked);
    setIsCheckedAll(allItemsSelected);
  }, [tagInfo]);

  const handleConfirmAndContinue = () => {
    // Use the selectedQrCodeItems array for further processing
    if (!isSubmitButtonPressed) {
      // Set the state to indicate that the button has been pressed
      if (selectedQrCodeItems.length > 0) {
        if (tagInfo.length > 0) {
          setIsSubmitButtonPressed(true);
          const qrCodeArray = selectedQrCodeItemsDetails.map(
            (item) => item.qrcode
          );
          const bulkQrData = {
            qrcodeList: qrCodeArray,
            status: "PROCESSED",
            remark: "ready now",
          };
          postBulkQrCode(storeCustomerId, storeId, bookingOrderId, bulkQrData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                setModalVisible(true);
                setApiResStatus(Res.status);
                if (Res.status) {
                  const timer = setTimeout(() => {
                    navigate("/OrdersGarmentInfo", {
                      state: {
                        storeCustomerId: storeCustomerId,
                        bookingOrderId: bookingOrderId,
                      },
                    });
                    setIsSubmitButtonPressed(false);
                  }, 1200);
                  return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          navigate("/OrdersGarmentInfo", {
            state: {
              storeCustomerId: storeCustomerId,
              bookingOrderId: bookingOrderId,
            },
          });
        }
      }
    }
  };

  const toggleCheckBox = (itemId) => {
    setTagInfo((prevData) =>
      prevData.map(
        (item) =>
          item.id === itemId ? { ...item, checked: !item.checked } : item // Uncheck other checkboxes
      )
    );

    setSelectedQrCodeItems((prevSelected) =>
      prevSelected.includes(itemId)
        ? prevSelected.filter((id) => id !== itemId)
        : [...prevSelected, itemId]
    );

    setSelectedQrCodeItemsDetails((prevDetails) =>
      prevDetails.some((item) => item.id === itemId)
        ? prevDetails.filter((item) => item.id !== itemId)
        : [...prevDetails, tagInfo.find((item) => item.id === itemId)]
    );
  };

  const handleClearSearch = () => {
    setSearchTermFocus("");
  };

  const handleScanRFID = ({ data }) => {

    if (!filteredData) return;

    const garmentEntry = [...filteredData.entries()].find(
      ([_, value]) => value.rfid === data || value.qrcode === data
    );

    if (garmentEntry) {
      const [key, garmentInfo] = garmentEntry;

      toggleCheckBox(garmentInfo.id); // assuming id is inside value

      handleAddItem()
      refocusInput();
      setSearchTermFocus("");
    }
  };

  const renderTagInfoItem = () => {
    return filteredData?.map((item, index) => {
      const garmentName =
        item.garmentAlias !== "" ? item.garmentAlias : item.garment;
      let RFID = item.rfid ? " | " + item.rfid : "";
      return (
        <div>
          <div className="flex-1">
            <div className="flex-row py-2 px-4">
              <div className="flex justify-content-center align-items-center">
                <div>
                  <Checkbox
                    size={20}
                    checked={item.checked}
                    color={item.checked ? "#00A3FF" : "#C1C9D3"}
                    onClick={() => toggleCheckBox(item.id)}
                  />
                </div>
                <div className="ml-4">
                  <p className="text-xl font-medium">
                    {item.qrcode}
                    {RFID}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex-1" style={{ backgroundColor: "#F6FAFF" }}>
              <div className="flex flex-row">
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Garment :
                    </p>
                    <p className="text-lg font-medium">
                      {garmentName.replace(/_/g, " ")}
                    </p>
                  </div>
                </div>
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Services :
                    </p>
                    <p className="text-lg font-medium">
                      {item.addOnList
                        .map((addOnItem) => addOnItem.serviceName)
                        .join(", ")}
                    </p>
                  </div>
                </div>
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Category :
                    </p>
                    <p className="text-lg font-medium">
                      {item.category.replace(/_/g, " ")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-row">
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Pack on :
                    </p>
                    <p className="text-lg font-medium">{item.garmentPack}</p>
                  </div>
                </div>
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Remark :
                    </p>
                    <p className="text-lg font-medium">{item.remark}</p>
                  </div>
                </div>
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Status :
                    </p>
                    <p className="text-lg font-medium">
                      {item.status.replace(/_/g, " ")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div onClick={() => refocusInput()}>
              <p> </p>
            </div>
            <div className="ml-3 flex justify-content-center align-items-center">
              <i
                className="pi pi-angle-left cursor-pointer"
                onClick={() => handleBackButton()}
                style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
              ></i>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Mark Ready
              </p>
            </div>
          </div>
          
            <div
              onClick={() => {
              setRfidMethod(!rfidMethod);
              setSearchTermView(false)
                setSearchTerm("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  height: 32,
                  width: 32,
                  marginRight: 30,
                }}
              >
                <img
                  src={"images/rfid-tags.png"}
                  style={{ height: 38, width: 38 }}
                />
              </div>
            </div>
          
          <div className="flex justify-content-center align-items-center mx-4 cursor-pointer">
            <i
              className="pi pi-search"
              onClick={() => {
                setSearchTermView(!searchTermView)
                setRfidMethod(false);

              }}
              style={{ fontSize: "25px", cursor: "pointer", color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: "#fff" }}>
       
         {rfidMethod && (
          <div className="my-2 mx-5 flex flex-1">
            <div className=" flex flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-xl"></InputIcon>
                <InputText
                  className="text-xl flex flex-1 py-1 px-5"
                  style={{ borderRadius: 30 }}
                  ref={inputRef}
                  value={searchTermFocus}
                  onChange={(e) => {
                    setSearchTermFocus(e.target.value);
                    handleScanRFID({ data: e.target.value });
                  }}
                  placeholder="Scan Garment"
                  showSoftInputOnFocus={false}
                  autoFocus={true}
                />
              </IconField>
            </div>
            {searchTermFocus && (
              <div
                className="flex justify-content-end align-items-center cursor-pointer"
                onClick={() => handleClearSearch()}
              >
                <p
                  className="text-3xl font-bold ml-4"
                  style={{ color: "red" }}
                >
                  X
                </p>
              </div>
            )}
          </div>
        )}
        {searchTermView && (
          <div>
            <div className="my-2 mx-5 flex flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-lg"> </InputIcon>
                <InputText
                  placeholder="Search QrCode"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="text-xl flex flex-1 py-1"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
              {searchTerm.length > 0 && (
                <div
                  className="flex justify-content-center align-items-center mx-4 cursor-pointer"
                  onClick={() => setSearchTerm("")}
                >
                  <i
                    className={"pi pi-times"}
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "red",
                    }}
                  ></i>
                </div>
              )}
            </div>
          </div>
        )}
        <div>
          <div
            className="flex flex-1 flex-row mx-4 my-2 gap-3"
            style={{
              borderRadius: 5,
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex-1 px-2 flex flex-column justify-content-center align-items-center"
              style={{
                backgroundColor: "#55BD5A",

                marginRight: 5,
                borderRadius: 5,
              }}
            >
              <p className="text-3xl font-semibold text-white">
                {tagInfo.length}
              </p>
              <p className="text-xl font-semibold text-white">
                Ready to Marked
              </p>
            </div>
            <div
              className="flex-1 px-2 flex flex-column justify-content-center align-items-center"
              style={{
                backgroundColor: "#3EB3E1",

                marginRight: 5,
                borderRadius: 5,
              }}
            >
              <p className="text-3xl font-semibold text-white">
                {selectedQrCodeItems.length}
              </p>
              <p className="text-xl font-semibold text-white">You Marked</p>
            </div>
          </div>
          {tagInfo.length > 0 && selectedQrCodeItems.length === 0 && (
            <div className="flex justify-content-center align-items-center mb-1">
              <p className="text-2xl font-medium" style={{ color: "red" }}>
                Please Select Tag To Continue
              </p>
            </div>
          )}
          {tagInfo.length === 0 && (
            <div>
              <div className="flex justify-content-center align-items-center mb-1 mt-4">
                <p className="text-2xl font-medium" style={{ color: "red" }}>
                  No Garment Tag Is Available For Processing
                </p>
              </div>
              <div className="flex justify-content-center align-items-center mb-1">
                <p className="text-2xl font-medium" style={{ color: "blue" }}>
                  Please Go Back
                </p>
              </div>
            </div>
          )}
        </div>

        {tagInfo.length > 0 && (
          <div className="flex-1" style={{ backgroundColor: "#EAEFF5" }}>
            <div className="flex-row py-2 px-4">
              <div className="flex justify-content-center align-items-center">
                <Checkbox
                  size={20}
                  checked={isCheckedAll}
                  color={isCheckedAll ? "#00A3FF" : "#C1C9D3"}
                  onClick={selectAllCheckboxes}
                />
              </div>
              <div className="ml-4">
                <p className="text-2xl font-medium">Order Garment Info</p>
              </div>
            </div>
          </div>
        )}

        {tagInfo.length > 0 && <div>{renderTagInfoItem()}</div>}
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={apiResStatus === true ? "success" : false}
          text={
            apiResStatus === true
              ? "Selected Garment is Marked Ready!"
              : "Please try again later"
          }
        />
      </div>
      <div className="relative mt-8">
        {tagInfo.length > 0 && (
          <div
            className="flex flex-1 flex-row  py-2 fixed z-2 bottom-0 w-full"
            style={{ backgroundColor: "white" }}
          >
            <div className="flex-1 flex-row mx-4 mb-1 gap-2">
              <Button
                className="p-2 w-full text-2xl border-1 flex justify-content-center"
                style={{
                  color: "#fff",
                  backgroundColor: "#2B70D7",
                  borderRadius: 5,
                }}
                onClick={() => handleConfirmAndContinue()}
                disabled={isSubmitButtonPressed}
              >
                Mark Ready
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PartialMarkReady;
